import { Inject, Injectable } from "@angular/core";
import { JwtHttpClientService } from "../../http/jwt-http-client.service";
import { AbstractHttpService } from "../../http/abstract-http.service";
import { ConfigurationService } from "../../configuration/configuration.service";
import { EntityData } from "../..";
import { ResponseContentType } from "@angular/http";
import { ResourceModule } from "../resource.module";
import { ReportRequestData } from "./report-request.data";
/**
 * Generic service for accessing an report resource from the server.
 *
 * Errors are returned as a #DataClientErrorMessage
 */
export class ReportService extends AbstractHttpService {
    /**
     * Constructs the service with a resource, Http service, and Error service.
     * The resource may be injected via the #ENTITY_RESOURCE alias
     * @param http HTTP Service
     * @param configService
     * @param nameSpace NameSpace that forms part of the URL
     */
    constructor(http, configService, nameSpace) {
        super();
        this.http = http;
        this.configService = configService;
        this.nameSpace = nameSpace;
    }
    /**
     * Request a report
     * @param {String} reportName
     * @param {EntityData<any>} criteria
     * @returns {Promise<ReportRequestData>} Data contains the report requested
     */
    requestReport(reportName, criteria) {
        return this.http.post(ReportService.URL_PREFIX + ReportService.REQUEST_PREFIX + this.nameSpace + "/" + reportName, criteria.toJSONString())
            .map((response) => EntityData.create(ReportRequestData).load(response.json()) || {})
            .catch((response) => this.handleServiceError(response))
            .toPromise();
    }
    /**
     * Retrieve a report request from the server
     * @param {String} identifier
     * @returns {Promise<ReportRequestData>}
     */
    getReportRequest(identifier) {
        return this.http.get(ReportService.URL_PREFIX + ReportService.REQUEST_PREFIX + identifier)
            .map((response) => EntityData.create(ReportRequestData).load(response.json()) || {})
            .catch((response) => this.handleServiceError(response))
            .toPromise();
    }
    /**
     * Returns a stream for the report content from the server
     * @param {string} identifier
     * @returns {Promise<{filename: string; data: Blob}>}
     */
    getReportStream(identifier) {
        return this.http.get(ReportService.URL_PREFIX + ReportService.DOWNLOAD_PREFIX + identifier, { responseType: ResponseContentType.Blob })
            .map(res => res.blob()).catch((response) => this.handleServiceError(response))
            .toPromise();
    }
    getDefaultSavedReportParameters(reportName, customReportName) {
        let url = ReportService.URL_PREFIX + ReportService.DEFAULT_SAVED_PREFIX + this.nameSpace + "/" + reportName;
        if (customReportName) {
            url = url + "/" + customReportName;
        }
        return this.http.post(url, {})
            .map((response) => response.json() || undefined)
            .catch((response) => this.handleServiceError(response))
            .toPromise();
    }
    getSavedReportParameters(reportName, identifier) {
        return this.http.post(ReportService.URL_PREFIX + ReportService.SAVED_PREFIX + this.nameSpace + "/" + reportName + "/" + identifier, {})
            .map((response) => response.json() || undefined)
            .catch((response) => this.handleServiceError(response))
            .toPromise();
    }
    /**
     * Indicates that the authenticated user has permission to request a report
     * @returns {Promise<boolean>}
     */
    static canRequestReport(configService, resource) {
        return configService.getString("resourcePrivilege/report/" + resource).then((privMask) => privMask ? configService.getBoolean("authorisation/" + privMask.replace("*", "generate")) : false);
    }
}
/**
 * Static URL prefix for all server side calls
 * @type {string}
 */
ReportService.URL_PREFIX = '/dataserver/report/';
ReportService.REQUEST_PREFIX = 'request/';
ReportService.DOWNLOAD_PREFIX = 'download/';
ReportService.SAVED_PREFIX = 'saved/';
ReportService.DEFAULT_SAVED_PREFIX = 'default/';
ReportService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ReportService.ctorParameters = () => [
    { type: JwtHttpClientService, },
    { type: ConfigurationService, },
    { type: undefined, decorators: [{ type: Inject, args: [ResourceModule.RESOURCE_NAMESPACE_KEY,] },] },
];
//# sourceMappingURL=report.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/resource/report/report.service.js
// module id = 145
// module chunks = 1